module.exports = __webpack_public_path__ + "img/blog_menu_pic2.61114fb5.png";